module.exports = __webpack_public_path__ + "ath_game_web/img/BSCscan_Logo.0a11ffd1.png";